import { useParams } from "react-router";
import UpsellV2 from "./Upsell.component";
import PaymentPage from "../StepsCalculatorPage/Components/PaymentPage/PaymentPage.component.";
import CheckoutPay from "../StepsCalculatorPage/Components/PaymentGateway/components/CheckoutPay/CheckoutPay.component";
import CheckoutSign from "../StepsCalculatorPage/Components/PaymentGateway/components/CheckoutSign/CheckoutSign.component";
import { isNativeMode } from "../../native/nativeMode";
import NativeUpsell from "../NativeUpsell/NativeUpsell.component";

export default function PaymentGatewayV2() {
  const { stepPayment } = useParams();

  return (
    <div id="payment-gateway-new" className="h-full w-full">
      {/* Organic native (F5c): 3 opciones de capital en vez del slider. */}
      {stepPayment === "1" && (isNativeMode() ? <NativeUpsell /> : <UpsellV2 />)}
      {stepPayment === "3" && <PaymentPage />}
      {stepPayment === "4" && <CheckoutPay />}
      {stepPayment === "5" && <CheckoutSign />}
    </div>
  );
}
